import axios, { InternalAxiosRequestConfig } from "axios";
import {mainStorage} from "@/composables/tools/main-storage.tools";
import {getToken} from "@/composables/auth";
import router from "@/router";

// Расширяем тип конфига для добавления кастомного поля
interface CustomAxiosRequestConfig extends InternalAxiosRequestConfig {
  _retryCount?: number;
}

const apiClient = axios.create({
  timeout: 45000,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: {
    serialize: (params) => {
      const searchParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          // Для массивов добавляем каждый элемент отдельно без []
          value.forEach(item => searchParams.append(key, item));
        } else if (value !== undefined && value !== null) {
          searchParams.append(key, String(value));
        }
      });
      return searchParams.toString();
    }
  }
});



const MAX_RETRIES = 5;

apiClient.interceptors.request.use(async (config: CustomAxiosRequestConfig) => {
  // Счетчик попыток запроса
  if (config._retryCount == null) {
    config._retryCount = 0;
  }

  if (config.url && !config.url.includes("/login")) {
    const token = mainStorage.getItem("access_token");
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});

apiClient.interceptors.response.use((response) => {
  (response.config as CustomAxiosRequestConfig)._retryCount = 0;
  return response;
}, async (error) => {

  const config = error.config as CustomAxiosRequestConfig;
  const status = error?.response?.status;

  if (status === 401 && window.location.pathname !== "/login") {

    // ====== Счетчик попыток авторизации
    if (config._retryCount && config._retryCount >= MAX_RETRIES) {
      // Редиректим на логин и блокируем дальнейшие попытки для этого запроса
      await router.push("/login");
      return Promise.reject(new Error(`Превышено ${MAX_RETRIES} попыток авторизации`));
    }
    config._retryCount = (config._retryCount || 0) + 1;
    // Счетчик попыток авторизации =====

    const refreshToken = await getToken();

    if (refreshToken === false) {
      await router.push("/login");
    } else {
      const originalRequest = error.config as CustomAxiosRequestConfig;
      delete originalRequest.headers["Authorization"];
      return apiClient.request(originalRequest);
    }
  } else if (status >= 400 && status < 600 ) {
    throw error;
  }
  else {
    console.log("Возникла ошибка при загрузке данных:", error);
  }
  return error;
});

export default apiClient;